import $ from 'jquery';

$('.burger').on('click', e => {
  const target = $(e.target).closest('.burger');

  if ($(target).hasClass('is-active')) {
    $(target).removeClass('is-active');
    $('body').removeClass('is-offscroll');
    $('.nav').removeClass('is-open');

    return;
  }

  $(target).addClass('is-active');
  $('body').addClass('is-offscroll');
  $('.nav').addClass('is-open');
});
